var Promise = require('promise');
var clipboard = require('clipboard');
var clipboardService = null;
import {QUERY_PARAMS} from 'a_common-folder/constants';
import generateUUID from '../helpers/generateUUID';

export default class HelpService {
    generateUUID = generateUUID;
    _urlParams = this.parse_url(window.location.search.substring(1));
    _tourName = typeof config === 'undefined' ? '' : config.title;
    _notify_agent_url = typeof config === 'undefined' ? '' : config.notify_agent_url;
    _leadgen_url = typeof config === 'undefined' ? '' : config.leadgen_url;

    constructor() {
    }

    get notify_agent_url() {
        return this._notify_agent_url;
    }
    get leadgen_url() {
        return this._leadgen_url;
    }

    get tourName() {
        return this._tourName;
    }

    get urlParams() {

        return this.updateAliasWithParams(this._urlParams);
    }

    updateAliasWithParams(urlParams){
        const params = Object.assign({}, urlParams);
        Object.keys(params).forEach((key) => {
            const query = QUERY_PARAMS.filter((param) => param.alias === key)[0];
            if(!query) return ;

            delete Object.assign(params, {[query.name]: params[key] === "0" ? 'false' : 'true' })[key];
        })

        return params;
    }

    get location() {
        try {
            return this.isExpireLink() ? window.top.length > 1 ? this.findLocation(window.top[0]): this.findLocation(window.top) : this.findLocation(window.location);
        } catch (e) {
            return window.location;
        }
    }

    findLocation(windowObj){
        try {
            windowObj.location.href;

            return windowObj.location
        }catch (e){
            return window.location;
        }
    }

    isExpireLink() {
        const inIframe = this.inIframe();
        try {
            return inIframe && parent.window.document.location.href.match(/vr-360-tour.com\/i/);
        } catch (e) {
            return false;
        }
    }

    inIframe() {
        try {
            return window.self !== window.top;
        } catch (e) {
            console.error(e);
            return true;
        }
    }

    getPermissions() {
        const urlParams = this.urlParams;
        const permissions = {};
        for (let i in urlParams) {
            if (i) {
                permissions[i] = urlParams[i] === 'true' ? true : urlParams[i] === 'false' ? false : urlParams[i];
            }
        }

        return permissions;
    }

    getPermissionsFromUrl(urlParams) {
        const permissions = {};
        for (let i in urlParams) {
            if (i) {
                permissions[i] = urlParams[i] === 'true' ? true : urlParams[i] === 'false' ? false : urlParams[i];
            }
        }

        return permissions;
    }

    checkVrIframeRestriction() {
        let chromeVersion = navigator.userAgent.match(/Chrom(e|ium)\/([0-9]+)\./);
        if (!chromeVersion || chromeVersion < 62) return false;
        return /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini|Mobile|mobile|CriOS/i.test(navigator.userAgent);
    }

    toggleControlls() {
        let e3Viewer = document.querySelector('#e3-viewer');
        e3Viewer.querySelector('.pannellum-panel-controls').classList.toggle('hidden');
        e3Viewer.querySelector('.pannellum-panel-content').classList.toggle('hidden');
    }

    parse_url(url) {
        var vars = url.split("&");
        var url_string = {};
        for (var i = 0; i < vars.length; i++) {
            var pair = vars[i].split("=");
            if (typeof url_string[pair[0]] === "undefined") {
                url_string[pair[0]] = decodeURIComponent(pair[1]);
            } else if (typeof url_string[pair[0]] === "string") {
                var arr = [url_string[pair[0]], decodeURIComponent(pair[1])];
                url_string[pair[0]] = arr;
            } else {
                url_string[pair[0]].push(decodeURIComponent(pair[1]));
            }
        }
        return url_string;
    }

    getArrayBuffer(url) {
        return new Promise(function (res, rej) {
            var request = new XMLHttpRequest();
            request.open('GET', url, true);
            request.responseType = 'arraybuffer';
            request.onload = function () {
                var status = request.status;

                if (status >= 200 && status < 300 || status === 304) {
                    res(request.response);
                } else {
                    rej(request.statusText);
                }
            };
            request.onerror = function (e) {
                rej(request.statusText);
                console.error(request.statusText);
            };
            request.send();
        })
    }

    ajaxCall(url, headers, method) {
        method = method || 'GET';
        return new Promise(function (res, rej) {
            var xhr = new XMLHttpRequest();
            xhr.open(method, url, true);
            if (headers && headers.length > 0) {
                var i = headers.length;
                while (i--) {
                    xhr.setRequestHeader(headers[i].type, headers[i].value);
                }
            }

            xhr.onload = function () {
                if (xhr.status === 200) {
                    res(xhr.responseText);
                } else {
                    rej(xhr.status);
                }
            };
            xhr.onerror = function (e) {
                rej(xhr.statusText);
                console.error(xhr.statusText);
            };
            xhr.send();
        })
    }

    post(url, params) {
        return new Promise((resolve, reject) => {
            let http = new XMLHttpRequest();
            let _params = '';

            if(typeof params === 'string' ){
                _params = params
            }else{
                Object.keys(params).forEach((key) => {
                    _params += `${key}=${params[key]}&`;
                });
            }

            _params = encodeURI(_params.slice(0, -1));

            http.open('POST', url, true);

            http.onload = function () {
                if (http.status === 200) {
                    resolve(http.responseText);
                } else {
                    reject(http.status);
                }
            };
            http.onerror = function (e) {
                reject(xhr.statusText);
                console.error(http.statusText);
            };
            http.send(_params);
        });
    }

    get(url) {
        return new Promise((resolve, reject) => {
            let http = new XMLHttpRequest();

            http.open('GET', url, true);

            http.onload = function () {
                if (http.status === 200) {
                    resolve(http.responseText);
                } else {
                    reject(http.status);
                }
            };
            http.onerror = function (e) {
                reject(xhr.statusText);
                console.error(http.statusText);
            };
            http.send(null);
        });
    }

    createInteractiveLink(uuid) {
        let url = this.location.href.split('?');

        let params = this.isExpireLink() ? '' : this._convertToUrl(this._urlParams);
        uuid = (uuid ? uuid : this.generateUUID()) + (params ? '&' + params.slice(1, params.length) : '');

        return url[0] + '?room=' + uuid;
    }

    get companyName() {
        return document.title.replace(`${this.tourName} - `, '').replace(/\s/, '-');
    }

    get domainPart() {
        return this.location.href.match(/^[^.]+\.(([^.].*?))\?(.*?)$/)[1];
    }

    clearRandomHash(string) {
        return string.replace(/(rand(\d+)\-)/, '');
    }

    appendRandomHash(string) {
        const hash = `rand${Math.floor(Math.random() * 100000)}`;

        return string.replace(`${this.location.protocol}//`, `${this.location.protocol}//${hash}-`);
    }

    noBranding() {
        return this.location.href.match(/\/\/www\./);
    }

    clearRoomId(){
        delete this._urlParams['room'];
    }

    clearSharelink(){
        delete this._urlParams['sharelink'];
    }

    redirectToTour() {
        this.clearRoomId();
        this.clearSharelink();

        const href = this.location.href.split('?')[0];
        const url = this.clearRandomHash(href);
        const params = this.isExpireLink() ? "" : this._convertToUrl(this._urlParams);

        this.location.href = url + params;
    }

    redirectToShareLink() {
        const href = this.location.href.split('?')[0];
        const url = this.clearRandomHash(href);
        if(this._urlParams['screen_share']) delete this._urlParams['screen_share'];

        const params = this.isExpireLink() ? "" : this._convertToUrl(this._urlParams);

        this.location.href = url + params + '&screen_share=true';
    }

    redirectToRandomDomain() {
        const href = this.location.href.split('?')[0];
        const url = this.clearRandomHash(href);
        const updateHash = this.appendRandomHash(url);
        const params = this.isExpireLink() ? this._convertToUrl({room: this._urlParams['room']}) : this._convertToUrl(this._urlParams);

        this.location.href = updateHash + params;
    }

    convertToUrl(obj) {
        this.clearSharelink();
        let url = this.location.href.split('?')[0];

        return `${url}${this._convertToUrl(obj)}`;
    }

    _convertToUrl(obj) {
        var params = '';

        for (var prop in obj) {
            prop ? (params += (!params ? '' : '&') + prop + '=' + obj[prop]) : '';
        }

        return params ? '?' + params : params;
    }

    getAudioContext() {
        return window.AudioContext ?
            new window.AudioContext() :
            window.webkitAudioContext ?
                new window.webkitAudioContext() :
                null;
    }

    copyToClipboard(modalId, btnClass, value, animation) {
        var modal = document.getElementById(modalId);
        if (!modal || clipboardService) {
            if (animation) {
                animation()
            }

            return;
        }

        btnClass = btnClass ? btnClass : 'copy';
        var btn = modal.getElementsByClassName(btnClass)[0];
        if (animation) {
            animation()
        } else {
            btn.classList.add('clickAnimation');
            setTimeout(function () {
                btn.classList.remove('clickAnimation');
            }.bind(this), 250);
        }

        clipboardService = new clipboard(btn, {
            text: function () {
                return value
            }
        });
        setTimeout(function () {
            btn.click();
        }.bind(this), 4);
        clipboardService
            .on('success', function (e) {
                setTimeout(function () {
                    clipboardService.destroy();
                }.bind(this), 100)
            }.bind(this));
    }
}
